import { useEffect } from 'react'
import { useBeforeUnload, useBlocker } from 'react-router'

// Local to developer tools; requires the app's existing data router.
export const useToolUnsavedChanges = (dirty: boolean, pending = false) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      (dirty || pending) &&
      (currentLocation.pathname !== nextLocation.pathname ||
        currentLocation.search !== nextLocation.search)
  )
  useEffect(() => {
    if (blocker.state !== 'blocked') return
    if (
      window.confirm(
        pending
          ? 'En innsending pågår. Hvis du forlater siden, kan utfallet bli ukjent. Forlate siden?'
          : 'Du har ulagrede endringer eller et vedlegg som ikke er lastet opp. Forkaste og forlate siden?'
      )
    ) {
      blocker.proceed()
    } else blocker.reset()
  }, [blocker, pending])

  useBeforeUnload((event) => {
    if (dirty || pending) {
      event.preventDefault()
      event.returnValue = ''
    }
  })
}
